export const TEXT = {
    GROUPSHACK: 'GroupShack',
    HOME: 'Home',
    MY_GROUPS: 'My Groups',
    MY_EVENTS: 'My Events',
    MY_COLLECTIONS: 'My Collections',
    LOGOUT: 'logout'  
};
